import classNames from 'classnames';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { AlertDetail } from 'hooks/useGetForecast';
import Date from 'components/common/dates/Date';
import { DateFormats } from 'utils/constants';

dayjs.extend(relativeTime);

type WeatherAlertProps = {
  alert: AlertDetail;
  className?: string;
};

function WeatherAlert({ alert, className }: WeatherAlertProps) {
  return (
    <div
      data-testid="weather-alert"
      className={classNames('rounded-lg border border-slate-300/70 text-sm', className)}
    >
      <div id="weather-alert-header" className="rounded-t bg-slate-300/70 p-2 text-slate-900">
        <div className="text-lg font-light">{alert.headline}</div>
      </div>

      <div id="weather-alert-body" className="p-2">
        <div className="mb-2 flex items-center justify-between">
          <div>
            <div className="font-bold">Effective</div>
            <div>{dayjs(alert.effective).fromNow()}</div>
            <Date date={alert.effective} format={DateFormats.TIMESTAMP_SHORT} />
          </div>
          <div className="text-right">
            <div className="font-bold">Expires</div>
            <div>{dayjs(alert.expires).fromNow()}</div>
            <Date date={alert.expires} format={DateFormats.TIMESTAMP_SHORT} />
          </div>
        </div>

        {alert.areas && (
          <div className="mb-2">
            <div className="font-bold">Affected Areas</div>
            <div>{alert.areas}</div>
          </div>
        )}

        <div className="mb-2">
          <div className="font-bold">Description</div>
          {alert.desc.split('\n').map((part, index) => (
            <div key={index}>{part}</div>
          ))}
        </div>

        {alert.instruction && (
          <div className="mb-2">
            <div className="font-bold">Instructions</div>
            {alert.instruction.split('\n').map((part, index) => (
              <div key={index}>{part}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default WeatherAlert;
